import { Styles } from 'react-select';

export const SelectStyles = {
    control: (styles: Styles<null, null, null>, state) => ({
        ...styles,
        // paddingInlineStart: '7.5px',
        borderRadius: '4px',
        minHeight: 'calc(1.5em + .75rem + 2px)',
        maxHeight: '95px',
        // overflowY: 'auto',
        height: 'auto',
        width: '100%',
        fontSize: '1em',
        fontFamily: 'inherit',
        borderColor: state.isFocused ? '#1b90fa' : '#bbbbbb',
        borderStyle: 'solid',
        borderWidth: '1px',
        boxShadow: state.isFocused ? '0 0 0 0.2rem rgb(0 123 255 / 25%)' : 'none',
        background: state.isDisabled ? '#fafbfc' : '#fff',
        cursor: state.isDisabled ? 'not-allowed' : 'pointer',
        pointerEvents: state.isDisabled && 'all !important',
        opacity: state.isDisabled ? 0.5 : 1
    }),
    multiValueLabel: (styles: Styles<null, null>) => ({
        ...styles,
        whiteSpace: 'wrap',
        textOverFlow: 'unset',
        overflow: 'unset',
        paddingInlineStart: '2px'
    }),
    input: (styles: Styles<null, null>) => ({
        ...styles,
        minWidth: '100px',
        margin: '0'
    }),
    menu: (styles: Styles<null, null>) => ({
        ...styles,
        width: '100%',
        zIndex: '999',
        maxHeight: '200px',
        overflowY: 'auto',
        '& > div:first-child': {
            overflowY: 'unset'
        }
    }),
    option: (styles: Styles<null, null>) => {
        return {
            ...styles,
            ':not(:last-child)': {
                borderBottom: '1px solid #bbbbbb'
            }
        };
    },
    dropdownIndicator: (styles: Styles<null, null>) => {
        return {
            ...styles,
            padding: '6px'
        };
    },
    valueContainer: (styles: Styles<null, null>) => {
        return {
            ...styles,
            padding: '2px 2px',
            overflowY: 'auto !important',
            maxHeight: '90px'
        };
    },
    indicatorSeparator: (styles: Styles<null, null>) => ({
        ...styles,
        display: 'none'
    }),
    multiValue: (styles: Styles<null, null>) => {
        return {
            ...styles,
            borderRadius: '7px',
            backgroundColor: 'rgb(240, 243, 250)'
        };
    }
};
